import type { ExperienceRole } from '../types/content';

export const experienceRoles: ExperienceRole[] = [
  {
    organization: 'LFP Broadcasting LLC',
    location: 'Luxembourg & USA',
    title: 'EVP, Broadcasting Worldwide & Member of Executive Management Team',
    period: '02/2023 — Present',
    description:
      'Leads global commercial strategy, worldwide distribution, engineering, and P&L for one of the industry\u2019s most complex broadcasting operations.'
  },
  {
    organization: 'Total Media Solutions',
    location: 'Luxembourg',
    title: 'Founder & Managing Director',
    period: '01/1999 — Present',
    description:
      'An independent strategic consultancy advising executive teams on international expansion, OTT/FAST/streaming transitions, and high-value partnerships.'
  }
];
